import useStyle from './signUpContent.style';
import { FormSignUp } from 'components/molecules/Forms/FormSignUp';
import { ExternalLink } from 'components/atoms/Links/ExternalLink';
import React, { useState } from 'react';
import { errorAndStateParams } from '../../../../helpers/forms/errorAndStateParams';
import {
  ProfParamsForm,
  signUpFieldData
} from '../../../../types/user/prof.def';
import { formatProfParamsForInscriptionStrapi } from '../../../../REST/register/formatProfParamsForInscriptionStrapi';
import registerProf from '../../../../REST/register/registerProf';
import goToPage from '../../../../helpers/page/goToPage';
import pages from '../../../../routes/pages';
import { MainFormState } from '../../../../types/forms/form.def';
import toast from 'react-hot-toast';

export const SignUpContent = () => {
  const [signUpForm, setSignUpForm] = useState<MainFormState<ProfParamsForm>>(
    signUpFieldData
  );
  const { values, errors } = signUpForm;

  const handleChange = e => {
    setSignUpForm({
      ...errorAndStateParams(e.target.name, e.target.value, signUpForm)
    });
  };

  const handlePolicy = (value: boolean) => {
    setSignUpForm({
      ...signUpForm,
      values: {
        ...signUpForm.values,
        policy: value
      }
    });
  };

  const submit = async () => {
    await setSignUpForm({ ...signUpForm, isLoading: true });
    let res;
    try {
      res = await registerProf(
        formatProfParamsForInscriptionStrapi(signUpForm.values)
      );
      const newState = res && {
        ...signUpForm,
        errors: { [res.field]: res.message },
        isValid: false,
        isLoading: false
      };
      await setSignUpForm(newState);
      goToPage(pages.SUCCESS.path);
    } catch (e) {
      toast.error(e.message);
      setSignUpForm({ ...signUpForm, isLoading: false });
      if (e.message === 'Auth.form.error.email.invalid')
        goToPage(pages.SUCCESS.path);
    }
  };

  const classes = useStyle();

  return (
    <div className={classes.root}>
      <h1 className={classes.title}>Demande de création de compte</h1>
      <p>
        Nos administrateurs s'occuperont de valider votre inscription. Vous
        pourrez ensuite inscrire votre classe.
      </p>
      <FormSignUp
        values={values}
        handleChange={handleChange}
        submit={submit}
        errors={errors}
        handlePolicy={handlePolicy}
        loading={signUpForm.isLoading}
      />
      <ExternalLink
        variant="helpLanding"
        textInside="Revenir à l'écran de connexion"
        link={pages.SIGN_IN.path}
        isOpenNewTab={false}
      />
    </div>
  );
};
